import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { InputGroup } from 'react-bootstrap';
import Vectoricon from '../../../../../assets/svg/Vector.svg';
import SearchableDropdownComponent from '@components/common/SearchableDropDown';
import './pregnancyOutcome.css';
import InfoBar from '@components/common/InfoBars';
import { getDataWithCache } from '@services/CommonApiService';
import endpoints from '@config/endpoints';

const NUMBER_OPTIONS = Array.from({ length: 20 }, (_, i) => ({
    value: String(i + 1).padStart(2, '0'),
    label: String(i + 1).padStart(2, '0'),
    disabled: false
}));

const NUMBER_OPTIONS_DELIVERY = Array.from({ length: 21 }, (_, i) => ({
    value: String(i + 0).padStart(2, '0'),
    label: String(i + 0).padStart(2, '0'),
    disabled: false
}));

const TOTAL_FEMALE_CHILD_OPTIONS = Array.from({ length: 20 }, (_, i) => ({
    value: String(i + 1).padStart(2, '0'),
    label: String(i + 1).padStart(2, '0'),
    disabled: false
}));

const PregnancyOutcome = ({
    pregnancyFormState,
    numberOfPregnancy,
    setNumberOfPregnancy,
    totalChildrenLive,
    setTotalChildrenLive,
    totalFemaleChild,
    setTotalFemaleChild,
    outcomes,
    setOutcomes,
    lmpDate
}: any) => {
    const [isChildShow, setIsChildShow] = useState<boolean>(false);
    const [isTotalFemaleChildDisabled, setIsTotalFemaleChildDisabled] = useState<boolean>(true);
    const [outcomeOptions, setOutcomeOptions] = useState<any>([]);

    useEffect(() => {
        const fetchData = (async () => {
            const pregnancyClosureDetails = await getDataWithCache<any>(`${endpoints.getClosureReason}`);
            if (pregnancyClosureDetails?.data && pregnancyClosureDetails?.data?.length > 0) {
                const formattedOptions = pregnancyClosureDetails.data.map((item: any) => ({
                    code: item.pregnancy_closure_reason_code === "is_delivery_outside_rch" ? "delivery" : "abortion",
                    name: item.pregnancy_closure_reason_name === "Is Delivery outside JANANI" ? "Delivery" : "Abortion",
                    id: item.pregnancy_closure_reason_id
                }));
                setOutcomeOptions(formattedOptions);
            }
        })
        fetchData();
        const num = parseInt(numberOfPregnancy?.value || '0', 10);
        if (num > 0) {
            let maxDate = dayjs();
            if (lmpDate) {
                maxDate = dayjs(lmpDate).subtract(1, 'month');
            } else if (pregnancyFormState?.dateOfRegistration?.value) {
                const registrationDate = dayjs(pregnancyFormState.dateOfRegistration.value);
                maxDate = registrationDate.subtract(1, 'month');
            }
            setOutcomes((prev: any) => {
                const newOutcomes = [...prev];
                while (newOutcomes.length < num) newOutcomes.push({ pregnancy_closure_reason_id: '', pregnancy_closure_reason_code: '', maxDate: maxDate, pregnancy_closure_date: null, error: '' });
                while (newOutcomes.length > num) newOutcomes.pop();
                return newOutcomes.map((item: any) => ({ ...item, maxDate: maxDate }));
            })
        } else {
            setOutcomes([]);
        }
    }, [numberOfPregnancy, lmpDate]);

    useEffect(() => {
        checkIsAnyDeliveryOptionSelected();
    }, [outcomes])

    useEffect(() => {
        const totalChildren = parseInt(totalChildrenLive?.value || '0', 10);
        if (totalChildren > 0) {
            setIsTotalFemaleChildDisabled(false);
        } else {
            setIsTotalFemaleChildDisabled(true);
            setTotalFemaleChild(null);
        }
    }, [totalChildrenLive])

    useEffect(() => {
        let maxDate = dayjs();
        if (lmpDate) {
            maxDate = dayjs(lmpDate).subtract(1, 'month');
        } else if (pregnancyFormState?.dateOfRegistration?.value) {
            const registrationDate = dayjs(pregnancyFormState.dateOfRegistration.value);
            maxDate = registrationDate.subtract(1, 'month');
        }
        
        setOutcomes((prev: any) => prev.map((item: any) => ({
            ...item,
            pregnancy_closure_date: item.pregnancy_closure_date ?? null,
            maxDate: maxDate
        })));

    }, [pregnancyFormState?.dateOfRegistration?.value, lmpDate])


    const checkIsAnyDeliveryOptionSelected = () => {
        const isDeliverySelected = outcomes.some((item: any) => item.pregnancy_closure_reason_code === 'delivery');
        setIsChildShow(isDeliverySelected);
    }

    const getFemaleChildOptions = () => {
        const totalChildren = parseInt(totalChildrenLive?.value || '0', 10);
        return TOTAL_FEMALE_CHILD_OPTIONS.map(opt => ({
            ...opt,
            disabled: parseInt(opt.value, 10) > totalChildren
        }));
    };

    const handleFormChange = (value: any, key: string) => {
        if (key === "numberOfPregnancy") setNumberOfPregnancy(value);
        else if (key === "totalChildrenLive") setTotalChildrenLive(value);
        else if (key === "totalFemaleChild") setTotalFemaleChild(value);
    };

    const handleOutcomeChange = (pregIndex: number, option: any) => {
        setOutcomes((prev: any) =>
            prev.map((item: any, i: any) =>
                i === pregIndex ? { ...item, pregnancy_closure_reason_id: option?.id, pregnancy_closure_reason_code: option?.code, error: '' } : item
            )
        );
    };

    const handleDateChange = (pregIndex: number, date: any) => {
        const firstDayOfMonth = date ? date.startOf('month') : null;
        setOutcomes((prev: any) =>
            prev.map((item: any, i: any) =>
                i === pregIndex
                    ? { ...item, pregnancy_closure_date: firstDayOfMonth, error: '' }
                    : item
            )
        );
    };

    return (
        <div className='pregnancy-outcome'>
            <div className="pregnancy-outcome-form">
                <div className='pregnancy-outcome-heading'>
                    <SearchableDropdownComponent
                        options={NUMBER_OPTIONS}
                        onChange={(value) => handleFormChange(value, "numberOfPregnancy")}
                        placeHolder={'Number of pregnancy'}
                        multipleSelection={false}
                        dropDownType={(numberOfPregnancy && numberOfPregnancy.isError) ? 'error' : 'general'}
                        dropLabelName={'No. of Previous Pregnancy'}
                        ifRequired={true}
                        dropDownDisable={false}
                        dropdownsearchable={true}
                        value={(numberOfPregnancy && numberOfPregnancy?.value) ? numberOfPregnancy : null}
                        errorMessage={numberOfPregnancy ? numberOfPregnancy?.errorMessage : ''}
                        isClearable={true}
                        showSelectedOption={false}
                    />
                </div>
                {numberOfPregnancy?.value && <div className="pregnancy-outcome-object">
                    <div className='heading'>Outcome</div>
                    {outcomes.map((item: any, idx: any) => (
                        <div className="pregnancy-outcome-object-contianer" key={idx}>
                            <div className='date-preg-reason-container'>
                                <div className="buttons-container">
                                    {outcomeOptions.map((option: any) => (
                                        <div key={option.code}>
                                            <label htmlFor={`${option.code}-${idx}`} className='option-data'>
                                                <input
                                                    className={'styled-radio'}
                                                    type="radio"
                                                    disabled={false}
                                                    onChange={() => handleOutcomeChange(idx, option)}
                                                    name={`outcomeObj-${idx}`}
                                                    value={option.name}
                                                    checked={item.pregnancy_closure_reason_code === option.code}
                                                    id={`${option.code}-${idx}`}
                                                    required={true}
                                                />
                                                <span>{option.name}</span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div className='month-year-selection'>
                                    <InputGroup>
                                        <DatePicker
                                            format={'MM-YYYY'}
                                            placeholder={'MM-YYYY'}
                                            maxDate={item?.maxDate ? item.maxDate : dayjs()}
                                            value={item?.pregnancy_closure_date ? dayjs(item.pregnancy_closure_date) : null}
                                            disabled={false}
                                            className="dateOfDeliveryOrAbortion"
                                            popupClassName="date-picker-popup"
                                            onChange={date => handleDateChange(idx, date)}
                                            suffixIcon={<Vectoricon />}
                                            showTime={false}
                                            picker="month"
                                        />
                                    </InputGroup>
                                </div>
                            </div>
                            {item?.error && <InfoBar
                                variant="danger"
                                message={item?.error ? item.error : ''}
                                className="searchable_drop_down_class"
                            />}
                        </div>
                    ))}
                </div>}

                {isChildShow && <div className='total-child-and-female-container'>
                    <div className='total-child-live'>
                        <SearchableDropdownComponent
                            options={NUMBER_OPTIONS_DELIVERY}
                            onChange={value => handleFormChange(value, "totalChildrenLive")}
                            placeHolder={'Total Children'}
                            multipleSelection={false}
                            dropDownType={(totalChildrenLive && totalChildrenLive?.isError) ? 'error' : 'general'}
                            dropLabelName={'Total Children'}
                            ifRequired={true}
                            dropDownDisable={false}
                            dropdownsearchable={true}
                            value={(totalChildrenLive && totalChildrenLive?.value) ? totalChildrenLive : null}
                            errorMessage={totalChildrenLive ? totalChildrenLive?.errorMessage : ''}
                            isClearable={true}
                            showSelectedOption={false}
                        />
                    </div>
                    <div className='total-female-child'>
                        <SearchableDropdownComponent
                            options={getFemaleChildOptions()}
                            onChange={value => handleFormChange(value, "totalFemaleChild")}
                            placeHolder={'Total Female Child'}
                            multipleSelection={false}
                            dropDownType={'general'}
                            dropLabelName={'Total Female Child'}
                            ifRequired={false}
                            dropDownDisable={isTotalFemaleChildDisabled}
                            dropdownsearchable={true}
                            value={totalFemaleChild}
                            errorMessage={''}
                            isClearable={true}
                            showSelectedOption={false}
                        />
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default PregnancyOutcome;